import { useState } from 'react';

import { Body, Button, TextInput } from '@growtherapy/sprout-ui';

import { CannedMessages, Messages } from '../../components/CannedMessages';
import { TrackingEvents, sendLoggingEvents } from '../../events';

interface QuickRepliesProps {
  cannedMessages: Messages;
  onSend: (message: string) => void;
}

export function QuickReplies({ cannedMessages, onSend }: QuickRepliesProps) {
  const [messageDraft, setMessageDraft] = useState('');
  const [showCustomReplyTextBox, setShowCustomReplyTextBox] = useState(false);

  return (
    <>
      <Body.Xsmall className='uppercase text-text-default'>Send a quick reply</Body.Xsmall>
      <div className='flex flex-row flex-wrap gap-2 w-full'>
        <CannedMessages
          messages={cannedMessages}
          onSelect={(cannedMessage: string) => {
            sendLoggingEvents(TrackingEvents.PROVIDER_TEMPLATE_MESSAGE_SEND);
            sendLoggingEvents(TrackingEvents.PROVIDER_QUICK_REPLY_CANNED);
            onSend(cannedMessage);
          }}
        />
        <Button
          disabled={showCustomReplyTextBox}
          size='sm'
          className='text-small'
          onClick={() => setShowCustomReplyTextBox(true)}
        >
          Custom reply
        </Button>
      </div>
      {showCustomReplyTextBox && (
        <form className='flex flex-row gap-2' onSubmit={(event) => event.preventDefault()}>
          <TextInput
            onChange={(event) => setMessageDraft(event.target.value)}
            placeholder='Write a custom reply'
            className='bg-neutral-100 h-10'
            mask='exclude'
            value={messageDraft}
            // autoFocus is okay in this example because this element will only get focus right after
            // someone clicks on "Custom reply". This gives enough context to an individual
            // about where they are on the screen and why.
            autoFocus // eslint-disable-line  jsx-a11y/no-autofocus
          />
          <Button
            size='sm'
            onClick={() => {
              sendLoggingEvents(TrackingEvents.PROVIDER_MESSAGE_SEND);
              sendLoggingEvents(TrackingEvents.PROVIDER_QUICK_REPLY_CUSTOM);
              onSend(messageDraft);
              setMessageDraft('');
            }}
            type='submit'
            disabled={!messageDraft.trim()}
          >
            Send
          </Button>
        </form>
      )}
    </>
  );
}
